// ** Icons Import
import { Home, Circle } from 'react-feather'

import { GrTime } from 'react-icons/gr'

export default [
  {
    id: 'dashboards',
    title: 'Dashboards',
    icon: <GrTime size={20} strokeWidth={1} />,
    badge: 'light-warning',
    children: [
      {
        id: 'analyticsDash',
        title: 'Analytics',
        icon: <Circle size={12} />,
        navLink: '/dashboard/analytics'
      }
    ]
  }
]
